module.exports = __webpack_public_path__ + "static/media/assign-success-illustration.37118f98.png";